<template>
<div class="leaps-energy-list">
<div class="container-fluid" v-if="getLeapsEnergyList.length > 0">
  <div class="table-responsive margin-Top-6Perc" >
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-align-center font-size-15px border-right">Energy Name</th>
          <th class="text-align-center font-size-15px border-right">Created TS</th>
          <th class="text-align-center font-size-15px border-right">Updated TS</th>
          <th class="text-align-center font-size-15px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="currLeapsEnergyObj in getLeapsEnergyList" :key="currLeapsEnergyObj.EnergyId" :currLeapsEnergyObj="currLeapsEnergyObj">
          <td class="border-right text-align-center col-lg-4 col-md-4 border-right">{{currLeapsEnergyObj.EnergyTitle}}</td>
          <td class="text-align-center col-lg-2 col-md-2 border-right">{{formatAndShowDate(currLeapsEnergyObj.CreatedTS)}}</td>
          <td class="text-align-center col-lg-2 col-md-2 border-right">{{formatAndShowDate(currLeapsEnergyObj.UpdatedTS)}}</td>
          <td class="text-align-center col-lg-3 col-md-3">
            <a class="cursor-pointer" @click="performClickOperation($event,'edit', currLeapsEnergyObj)"> Edit </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'view', currLeapsEnergyObj)"> View </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'delete', currLeapsEnergyObj)"> Delete </a>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <update-leaps-energy-overlay v-if="openEditOverlay" :currSelectedObj="currSelectedObj" @emittedValue="updateEmittedValue"></update-leaps-energy-overlay>
  <view-leaps-energy-overlay v-if="openViewOverlay" :currSelectedObj="currSelectedObj" @emittedValue="updateEmittedValue"></view-leaps-energy-overlay>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteCurrentLeapsEnergy"></confirmation-alert>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <loader></loader>
</div>
</template>
<script>
import { leapsEnergyService } from '@/server-util/leaps-energy-service'
import UpdateLeapsEnergyOverlay from '@/components/leaps/energy/UpdateLeapsEnergyOverlay'
import ViewLeapsEnergyOverlay from '@/components/leaps/energy/ViewLeapsEnergyOverlay'
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import Loader from '@/components/dashboard/Loader'
import findIndex from 'lodash/findIndex'
export default {
  props: ['leapsEnergyList'],
  computed: {
    getLeapsEnergyList: {
      get: function () {
        return this.leapsEnergyList
      }
    }
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      currSelectedObj: null,
      openEditOverlay: false,
      openViewOverlay: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: ''
    }
  },
  name: 'leaps-energy-list',
  methods: {
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button confirmation overlay
      this.showConfirmationBox = value
      this.currSelectedObj = null
    },
    updateEmittedValue (recievedObj) {
      this.openEditOverlay = !recievedObj.closeOverlay
      this.openViewOverlay = !recievedObj.closeOverlay
      this.$store.state.isOverlayVisible = false
    },
    performClickOperation: function (event, operationName, selectedObj) {
      this.currSelectedObj = selectedObj
      switch (operationName) {
        case 'edit':
          this.openEditOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'view':
          this.openViewOverlay = true
          this.$store.state.isOverlayVisible = true
          break
        case 'delete':
          this.showConfirmationBox = true
          this.prefixString = 'Are you sure you want to delete '
          this.postString = '\'' + this.currSelectedObj.EnergyTitle + '\' energy?'
          break
      }
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    deleteCurrentLeapsEnergy (value) {
      this.showConfirmationBox = false
      if (value) {
        var storeObj = this.$store
        if (
          this.currSelectedObj.EnergyId !== undefined &&
          this.currSelectedObj.EnergyId !== null
        ) {
          this.$store.state.isLoading = true
          leapsEnergyService
            .deleteLeapsEnergy(
              storeObj.state.access_token,
              this.currSelectedObj.EnergyId
            )
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  this.checkAndDeleteFromMasterLeapEnergyList()
                  this.$store.state.isLoading = false
                } else {
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                  this.$store.state.isLoading = false
                }
              },
              errorObj => {
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = errorObj.response.data.statusText
              }
            )
        } else {
          console.log(
            'EnergyId is NULL hence declined DELETE LEAP ENERGY Operation'
          )
        }
      }
    },
    checkAndDeleteFromMasterLeapEnergyList: function () {
      const foundIndex = findIndex(this.$store.state.leapsEnergyList, (obj) => {
        return obj.EnergyId === this.currSelectedObj.EnergyId
      })
      if (foundIndex > -1) {
        this.$store.state.leapsEnergyList.splice(foundIndex, 1)
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'update-leaps-energy-overlay': UpdateLeapsEnergyOverlay,
    'view-leaps-energy-overlay': ViewLeapsEnergyOverlay,
    'confirmation-alert': ConfirmationOverlay
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.leaps-energy-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-center{
  text-align: center !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/leaps/energy/LeapsEnergyList.vue